import { render, staticRenderFns } from "./autocalibrationtagsmodal.vue?vue&type=template&id=20897074&scoped=true"
import script from "./autocalibrationtagsmodal.vue?vue&type=script&lang=js"
export * from "./autocalibrationtagsmodal.vue?vue&type=script&lang=js"
import style0 from "./autocalibrationtagsmodal.vue?vue&type=style&index=0&id=20897074&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20897074",
  null
  
)

export default component.exports